import { useEffect } from "react";
import { NaeSSchemaMap } from "../../config/NaeSSchema";
import { useDataCache } from "./DataCacheProvider";
import { useSelector } from "react-redux";
import { SelectorInvoiceNae } from "../Models/ormSelectors";

interface ChildId {
  id: number
}

export interface IInvoiceModelNae {
    id: number,
scopes: any,
badges: any,

}

export const IInvoiceFieldsNae = [
    "id",
    "scopes",
    "badges"
];

export function useInvoiceHookNae(id: number) : IInvoiceModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorInvoiceNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Invoice.schema,
        fields: IInvoiceFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
